import { Button, Flex } from "@qws-org/ui-kit";
import type { FC } from "react";

import type {
  ActionActionItemUnion,
  ExternalNavigation,
  InternalNavigation,
} from "~/core";
import { isButtonVariant } from "~/features/headerV4/isButtonVariant";
import type { MainBannerV4Props } from "~/features/main-banner-v4/MainBannerV4";

const isExternalLink = (
  action: ActionActionItemUnion | null | undefined,
): action is ExternalNavigation => {
  return "href" in (action ?? {});
};
const isInternalLink = (
  action: ActionActionItemUnion | null | undefined,
): action is InternalNavigation => {
  return "page" in (action ?? {});
};

export const MainBannerV4Buttons: FC<MainBannerV4Props> = ({
  data,
  getUrl,
  onCallAction,
  isControlInactive,
}) => {
  return (
    <Flex
      align="center"
      justify="center"
      gap={16}
      md={{
        justify: "flex-start",
        m: { mt: 0 },
      }}
      d={{ gap: 16 }}
      m={{ mb: 16, mt: "auto" }}
    >
      {data?.controls
        ?.filter((control) => {
          if (control?.main_banner_v4_controls_id?.action) {
            return !isControlInactive(
              control.main_banner_v4_controls_id.action,
            );
          }

          return true;
        })
        .map((control, idx) => {
          const controlAction = control?.main_banner_v4_controls_id?.action;
          const action = controlAction?.action?.[0];
          let href;
          if (isExternalLink(action?.item)) {
            href = action.item.href ?? undefined;
          }
          if (isInternalLink(action?.item)) {
            href = action.item.page ? getUrl(action.item.page) : undefined;
          }

          return (
            <Button
              horizontalAlign="center"
              href={href}
              key={control?.id}
              variant={
                isButtonVariant(control?.main_banner_v4_controls_id?.variant)
                  ? control?.main_banner_v4_controls_id?.variant
                  : "default"
              }
              size="small"
              fontWeight="desktop.bold"
              md={{
                p: 18,
                minWidth: 215,
                fontSize: "button.desktop.medium",
                lineHeight: "button.desktop.medium",
              }}
              onPress={() => {
                if (controlAction) {
                  onCallAction(controlAction);
                }
              }}
              p={12}
              minWidth={148}
              data-testid={`main-banner-v4-button-${idx}`}
            >
              {control?.main_banner_v4_controls_id?.text}
            </Button>
          );
        })}
    </Flex>
  );
};
